import { render, staticRenderFns } from "./DenunciationList.vue?vue&type=template&id=29dd51bc&"
import script from "./DenunciationList.vue?vue&type=script&lang=js&"
export * from "./DenunciationList.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports